import Routing from "./routes/Routing";

function App() {
  return (
    <div className="font-sans">
      <Routing />
    </div>
  );
}

export default App;
